export enum DomElementEvent {
  // Standard events
  click = 'click',
  submit = 'submit',
  mousemove = 'mousemove',
  mouseup = 'mouseup',
  mouseenter = 'mouseenter',
  mouseleave = 'mouseleave',
  touchstart = 'touchstart',
  touchmove = 'touchmove',
  touchend = 'touchend',
  change = 'change',

  // Custom events emitted by BrowserViewport on behalf of an Element
  enterViewport = 'enter-viewport',
  leaveViewport = 'leave-viewport',
}
